var map = {
	"./auth/google.png": 2771,
	"./auth/google_blank.png": 5760,
	"./auth/seznam.svg": 7659,
	"./auth/seznam_white.svg": 1061,
	"./auth/shoptet.png": 1559,
	"./hero-cs.png": 4648,
	"./hero-en.png": 4791,
	"./logo-cs-black.svg": 8694,
	"./logo-cs-blue.png": 8906,
	"./logo-cs.svg": 556,
	"./logo-en-black.svg": 5761,
	"./logo-en.svg": 6775,
	"./logos/shoptet/shoptet-logo-primary-white.svg": 6661,
	"./logos/shoptet/shoptet-logo-primary.svg": 6081,
	"./logos/shoptet/shoptet-logo-sign-full.png": 1471,
	"./logos/shoptet/shoptet-logo-sign-outline.png": 3428,
	"./logos/upgates/upgates-logo-inverted.svg": 2966,
	"./logos/upgates/upgates-logo-vertical-inverted.svg": 4975,
	"./logos/upgates/upgates-logo-vertical.svg": 5959,
	"./logos/upgates/upgates-logo.svg": 4884,
	"./logos/upgates/upgates-sign.svg": 2298,
	"./logos/vojs.png": 4816,
	"./pictures/ai_bg.jpeg": 752,
	"./pictures/avatar_real.png": 9405,
	"./robot.svg": 3032,
	"./robot_black.png": 3971,
	"./robot_white.png": 8941,
	"./robot_white.svg": 9122,
	"./theme/banner/banner-bg.svg": 8623,
	"./theme/blog/dotted-shape.svg": 8873,
	"./theme/blog/quote-bg.svg": 5121,
	"./theme/faq/shape.svg": 8572,
	"./theme/footer/shape-1.svg": 2943,
	"./theme/footer/shape-2.svg": 7596,
	"./theme/footer/shape-3.svg": 7309,
	"./theme/hero/dotted-shape.svg": 8577,
	"./theme/team/dotted-shape.svg": 5704,
	"./theme/team/shape-2.svg": 4914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;